/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import { withPrefix } from "gatsby";
import insta from "../../images/insta-icon.svg";

const SocialReviewCard = ({ props }) => {
    const { feature_image, title, slug } = props;
    return (
        <a href={withPrefix(`/${slug}`)}>
            <div
                css={css`
                    height: 45rem;
                    width: 31rem;
                    background-image: url(${feature_image});
                    border-radius: 2rem;
                    position: relative;
                    margin: 1rem;
                    background-repeat: no-repeat;
                    background-size: cover;
                    box-shadow: 0px 0px 8px 2px rgb(0 0 0 / 14%);

                    @media (max-width: 699px) {
                        height: 30rem;
                        width: 25rem;
                    }
                    @media (max-width: 560px) {
                        height: 25rem;
                        width: 16rem;
                    }

                    @media (max-width: 380px) {
                        height: 21rem;
                        width: 12rem;
                    }
                `}
            >
                <div
                    css={css`
                        background: #000;
                        display: block;
                        height: inherit;
                        opacity: 0.3;
                        border-radius: 2rem;
                    `}
                >
                    <div
                        css={css`
                            position: absolute;
                            bottom: 0;
                            padding: 1rem 2rem;
                            display: flex;
                            flex-direction: row;
                            cursor: pointer;
                        `}
                    >
                        <div
                            css={css`
                                height: 2rem;
                                width: 2rem;
                                background-size: cover;
                                background-repeat: no-repeat;
                                background-image: url(${insta});
                            `}
                        />
                        <div
                            css={css`
                                color: #ffffff;
                                font-weight: 300;
                                line-height: normal;
                                font-size: 1.5rem;
                                text-align: start;
                                width: 25rem;
                                margin: auto;
                                margin-left: 1rem;
                                @media (max-width: 699px) {
                                    width: 20rem;
                                }
                                @media (max-width: 560px) {
                                    width: 10rem;
                                    font-size: 1.2rem;
                                    word-break: break-all;
                                }
                                @media (max-width: 380px) {
                                    width: 7rem;
                                    font-size: 1.2rem;
                                    word-break: break-all;
                                }
                            `}
                        >
                            by {title}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default SocialReviewCard;
